// Brand assets must remain local so the website and installed mobile apps do
// not lose their identity when an external CDN is unavailable.
export const STANDARD_LOGO_SRC = '/media/the-standard-logo-transparent.png';
